import { useLang } from "../context/LangProvider";
import { useWords,useTitle } from "../hooks";
import {
  HomeBanner,
  HomeServices,
  HomeStats,
  HomeWhyUs,
  HomeTestimonials,
  HomePartners,
} from "../components";

const Home = () => {
  const [lang] = useLang();
  const langWords = useWords(lang);
  useTitle(langWords.home || "");
  return (
    <div>
      <HomeBanner langWords={langWords} />
      <HomeServices langWords={langWords} />
      <HomeStats langWords={langWords} />
      <HomeWhyUs langWords={langWords} />
      <HomeTestimonials langWords={langWords} />
      <HomePartners langWords={langWords} />
    </div>
  );
};

export default Home;
